export const environment = {
  production: true,
  training: true,
  api_server: 'https://marketmanager.marktgilde.de:8443/',
  api_server_training: 'https://marketmanager-training.marktgilde.divve.cloud/',
  api_server_version: 'v5',
  merchant_webapp: 'https://mge-k3q.beta.reaze.cloud/',
  pimcore: 'https://mge-p2x.beta.reaze.cloud/',
  merchant_webapp_user: 'marktgilde',
  merchant_webapp_password: 'b1I3b8d1t4K2h1E3',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts